export const SET_USERS = "SET_USERS";
export const ADD_USER_TO_LIST = "ADD_USER_TO_LIST";
export const SET_USER = "SET_USER";
export const ADD_NEW_USER = "ADD_NEW_USER";
export const CLEAR_USER = "CLEAR_USER";
export const REMOVE_USER = "REMOVE_USER";
export const UPDATE_CLIENT_EMAIL = "UPDATE_CLIENT_EMAIL";
